/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ln_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free loan and EMI calculator. Work out the monthly payment, total paid, and total interest on a loan or mortgage. Runs in your browser.`)
};

const es_ln_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de préstamos e EMI. Calcula el pago mensual, el total pagado y el interés total de un préstamo o hipoteca. Se ejecuta en su navegador.`)
};

const de_ln_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Darlehens- und EMI-Rechner. Berechnen Sie die monatliche Rate, den Gesamtbetrag und die Gesamtzinsen für ein Darlehen oder eine Hypothek. Läuft direkt in Ihrem Browser.`)
};

const nl_ln_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis lening- en EMI-calculator. Bereken de maandelijkse betaling, totaal betaald en totale rente op een lening of hypotheek. Werkt in uw browser.`)
};

const fr_ln_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculatrice gratuite de prêt et d'EMI. Calculez le paiement mensuel, le total payé et l'intérêt total sur un prêt ou une hypothèque. Fonctionne dans votre navigateur.`)
};

const it_ln_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore gratuito per prestiti e EMI. Calcola il pagamento mensile, il totale pagato e l'interesse totale su un prestito o mutuo. Viene eseguito nel tuo browser.`)
};

const pt_br2_ln_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de empréstimo e EMI. Calcule o pagamento mensal, o total pago e o total de juros em um empréstimo ou hipoteca. Funciona no seu navegador.`)
};

const pt_ln_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de empréstimo e EMI. Calcule o pagamento mensal, o total pago e o total de juros num empréstimo ou hipoteca. Funciona no seu navegador.`)
};

const ja_ln_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「無料のローンおよびEMI計算機。ローンやモーゲージの月々の支払額、合計支払額、合計利息を計算します。ブラウザで実行されます。」`)
};

const zh_ln_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的贷款与EMI计算器。计算贷款或房贷的月供、还款总额和利息总额，完全在您的浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ln_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ln_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ln_tool_description", locale)
	if (locale === "en") return en_ln_tool_description(inputs)
	if (locale === "es") return es_ln_tool_description(inputs)
	if (locale === "de") return de_ln_tool_description(inputs)
	if (locale === "nl") return nl_ln_tool_description(inputs)
	if (locale === "fr") return fr_ln_tool_description(inputs)
	if (locale === "it") return it_ln_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_ln_tool_description(inputs)
	if (locale === "pt") return pt_ln_tool_description(inputs)
	if (locale === "ja") return ja_ln_tool_description(inputs)
	return zh_ln_tool_description(inputs)
};